import { lazy } from "react";

const PDDForm = lazy(() => import("../pages/HRINF/PersonnelDocumentDigitization/PDDForm"));

const personnelDigitizationRoutes = [
  {
    id: Math.ceil(Math.random()) * 100000,
    type: "add",
    path: "/personnel-document-digitization/add/:firstName/:lastName/:nationalCode/:cellphone",
    element: (
      <PDDForm observe={false} edit={false} fromDraft={false} projectNameClientLoggedInFrom="PDD" />
    ),
  },
  {
    id: Math.ceil(Math.random()) * 100000,
    type: "edit",
    path: "/personnel-document-digitization/edit/:firstName/:lastName/:nationalCode/:cellphone",
    element: (
      <PDDForm observe={false} edit={true} fromDraft={false} projectNameClientLoggedInFrom="PDD" />
    ),
  },
  {
    id: Math.ceil(Math.random()) * 100000,
    type: "edit",
    path: "/personnel-document-digitization/333status/:firstName/:lastName/:nationalCode/:cellphone",
    element: (
      <PDDForm
        observe={false}
        edit={true}
        fromDraft={false}
        getByNationalCode={true}
        projectNameClientLoggedInFrom="PDD"
      />
    ),
  },
  // {
  //   id: Math.ceil(Math.random()) * 100000,
  //   type: "edit",
  //   path: "/personnel-document-digitization/edit/:firstName/:lastName/:nationalCode/:cellphone",
  //   element: <PDDForm observe={false} edit={true} fromDraft={false} status=""/>,
  // },
  // {
  //   id: Math.ceil(Math.random()) * 100000,
  //   type: "add",
  //   path: "/JobApply/add",
  //   element: <PDDForm observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   id: Math.ceil(Math.random()) * 100000,
  //   type: "add",
  //   path: "/job-apply/edit/:id",
  //   element: <PDDForm observe={false} edit={false} fromDraft={false} editHr={true} />,
  // },
];

export default personnelDigitizationRoutes;
